import isEqual from 'react-fast-compare';
import { FilterToolbarItem, FilterToolbarItemId } from 'src/components/Filters';
import { ContentId } from 'src/utils/constants/contentId';
import { COLLECTION_FILTER_OP_TO_CID } from 'src/utils/constants/contentIdMaps';
import { DeliveryType, FilterOperationType } from 'src/WebApiController';

import { DeliveryTypeMultiSelector } from '../../Selectors/DeliveryTypeSelector';

export type DeliveryTypeMultiFilter = {
  deliveryType?: DeliveryType | null;
  operations?: {
    deliveryTypeOp?: FilterOperationType | null;
  } | null;
};

export const useDeliveryTypeMultiFilters = <
  TFilter extends DeliveryTypeMultiFilter,
>({
  query,
  setQuery,
  supportMultiOperation = false,
  isHorizontalLayout = false,
}: {
  query: TFilter;
  setQuery: (query: TFilter) => void;
  supportMultiOperation?: boolean;
  isHorizontalLayout?: boolean;
}): FilterToolbarItem => {
  const currentValue = query.deliveryType ? [query.deliveryType] : [];

  return {
    filterId: 'deliveryType' as FilterToolbarItemId,
    labelContentId: ContentId.Delivery,
    filterQueryKeys: ['deliveryType'] as FilterToolbarItemId[],
    filterItem: (
      <DeliveryTypeMultiSelector
        style={{ width: '100%' }}
        values={currentValue}
        operation={query.operations?.deliveryTypeOp ?? null}
        operationOptionsContent={
          supportMultiOperation ? COLLECTION_FILTER_OP_TO_CID : undefined
        }
        isHorizontalLayout={isHorizontalLayout}
        enableEmptySelection
        onChange={({ newValues: deliveryTypes, operation }) => {
          const newDeliveryType = deliveryTypes?.length
            ? deliveryTypes[0]
            : null;
          if (
            !isEqual(newDeliveryType, query.deliveryType) ||
            operation !== query.operations?.deliveryTypeOp
          ) {
            setQuery({
              ...query,
              deliveryType: newDeliveryType,
              operations: supportMultiOperation
                ? {
                    ...query.operations,
                    deliveryTypeOp: operation ?? null,
                  }
                : null,
            });
          }
        }}
      />
    ),
  };
};
